export default __webpack_public_path__ + "static/media/logouc.9626d43e.png";